import React from "react";
import { motion } from "framer-motion";

const SectionHeading = ({ index, label, title }) => (
    <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true, margin: "-80px" }}
        className="mb-16"
    >
        <div className="mb-4 flex items-center gap-4">
            <span className="font-mono text-xs text-accent">/{index}</span>
            <span className="h-px flex-1 bg-line" />
            <span className="font-mono text-xs uppercase tracking-widest2 text-faint">
                {label}
            </span>
        </div>
        <h2 className="text-4xl font-medium tracking-tight text-fg sm:text-5xl">
            {title}
        </h2>
    </motion.div>
);

export default SectionHeading;